import { pwInput, pwLabel, pwSectionTitle } from "./policyWizardFieldStyles";

/**
 * Onboarding-style letters / communication step shell.
 */
export default function PolicyLettersStepSection({
  darkMode = false,
  title = "Communication & letters",
  children,
  footer,
}) {
  return (
    <div>
      <h4 className={pwSectionTitle(darkMode)}>{title}</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{children}</div>
      {footer}
    </div>
  );
}

export function PolicyLettersField({ darkMode, label, children, className = "" }) {
  return (
    <div className={className}>
      <label className={pwLabel(darkMode)}>{label}</label>
      {children}
    </div>
  );
}

export function PolicyLettersSelect({ darkMode, value, onChange, options = [], placeholder }) {
  return (
    <select value={value} onChange={onChange} className={pwInput(darkMode)}>
      {placeholder ? <option value="">{placeholder}</option> : null}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}

export function PolicyLettersYesNo({ darkMode, value, onChange }) {
  return (
    <PolicyLettersSelect
      darkMode={darkMode}
      value={value}
      onChange={onChange}
      options={[
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ]}
    />
  );
}
